import { FeatureFlag } from './featureFlags'

export const defaultConfig = {
  [FeatureFlag.RELEASE_NOVO_LAYOUT_NAOENCOTRADO]: false,
}
